export default __webpack_public_path__ + "static/media/isla-aillaquillen-turista-sacando-foto-vista-volcan.42c73d63.jpeg";